
import { mapActions, mapGetters } from 'vuex'
import store from '@/common/config/store'

export default {

  data: () => ({
    store,
    loading: false
  }),

  computed: {
    ...mapGetters([
      'periodicTransfers'
    ])
  },

  methods: {

    ...mapActions([
      'togglePermanentTransfer'
    ]),

    deleteTransfer (transferId) {
      this.showModal({
        childVue: 'delete',
        dataModel: {
          url: `${store.api.base}/transfers/${transferId}`,
          title: this.$i18n.t('modal.delete.transfer.title'),
          content: this.$i18n.t('modal.delete.transfer.content')
        }
      })
    },

    toggle (transfer) {
      if (!this.loading) {
        this.loading = true
        this.togglePermanentTransfer(transfer).then(response => {
          Object.assign(transfer, response.data)
          this.loading = false
        })
      }
    },

    showDetails (transfer) {
      this.showSidePanel({
        childVue: 'transfer-detail',
        dataModel: transfer,
        wrapperClass: 'sidepanel--md',
      })
    },
  }
}
